"use strict";
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomRelease = exports.CustomLabelType = void 0;
/**
 * APIs that let solutions interact with the top bar and personalize it, e.g. configuring the
 * solution area on the left, setting up workspaces, custom search, etc.
 *
 * ***Import:***
 *
 * ```typescript
 * import topbar from '@adobe/exc-app/topbar';
 * ```
 *
 * ***Default export:***
 *
 * [TopbarApi](../interfaces/topbar.topbarapi.md#interface-topbarapi)
 *
 * ***Usage:***
 *
 * ```typescript
 * import topbar from '@adobe/exc-app/topbar';
 *
 * topbar.customEnvLabel = 'Beta';
 * ```
 * @packageDocumentation
 * @module topbar
 */
const Global_1 = require("./src/Global");
var CustomLabelType;
(function (CustomLabelType) {
    /**
     * The default label type.
     */
    CustomLabelType["ENVIRONMENT"] = "ENVIRONMENT";
    /**
     * Renders as a release badge. Can only render one badge and only for solutions in GA release.
     */
    CustomLabelType["RELEASE"] = "RELEASE";
})(CustomLabelType = exports.CustomLabelType || (exports.CustomLabelType = {}));
var CustomRelease;
(function (CustomRelease) {
    /**
     * "Trial" release badge. Can only be shown if your solution is already in GA.
     */
    CustomRelease["TRIAL"] = "TRIAL";
})(CustomRelease = exports.CustomRelease || (exports.CustomRelease = {}));
const topbar = (0, Global_1.connect)('topbar', [
    ['customEnvLabel'],
    ['onHeroClick', true],
    ['setCustomSearch', true],
    ['setCoachMark', true],
    ['setFeedbackButton', true],
    ['solution'],
    ['workspaces']
]);
exports.default = topbar;
//# sourceMappingURL=topbar.js.map